// client/src/hooks/useNow.ts
import { useEffect, useState } from 'react';

/**
 * Returns a Date that updates on an interval (default 1000ms).
 * Causes consuming components to re-render each tick.
 */
export function useNow(intervalMs = 1000): Date {
  const [now, setNow] = useState<Date>(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
